// extracted by mini-css-extract-plugin
export var icon = "_5f-1";
export var subtext = "_5f-0";